import React from 'react';
import Prelogo from '../Images/Header/prelogo.png';
import './CSS/Preloader.css'

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="preloader-content">
        <div className="logo-container">
          <div className="logo-circle">
            <div className="logo-inner">
              <div className="logo-icon">
                <img 
                  src={Prelogo} 
                  alt="Ali Darbar Logo" 
                  className="logo-image" 
                />
              </div>
            </div>
          </div>
          <div className="logo-pulse"></div>
        </div>
        <h3 className="hotel-name">Ali Darbar</h3>
        <p>Preparing your culinary experience...</p>
      </div>
    </div>
  );
};

export default Preloader;